import React from "react";
import styles from "./style.module.less";
import { processOssImage } from "@/utils/image";

interface BtnBoxProps {
  onOpenPlay: () => void;
  btnUrl: string;
  showCount: boolean;
  count: number;
}

const LotteryBtn: React.FC<BtnBoxProps> = ({
  onOpenPlay,
  btnUrl,
  showCount,
  count,
}) => {
  return (
    <div className={styles.btnBox}>
      <div
        className={styles.btn}
        onClick={onOpenPlay}
        style={{
          backgroundImage: `url(${processOssImage(btnUrl)})`,
          backgroundSize: "100% auto", // 背景图覆盖整个容器
          backgroundRepeat: "no-repeat", // 背景图不重复
          backgroundPosition: "center", // 背景图居中
        }}
      >
        <div className={styles.drawNumComCss}>
          {showCount && (
            <div className={styles.drawNum}>
              <div>剩余{count || 0}次</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LotteryBtn;
